import styled from "styled-components";
import {
  EmptyText as SharedEmptyText,
  getToneTokens,
  MetricCard,
  MetricLabel,
  MetricSub,
  MetricValue,
  PageActions,
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
  TabButton,
  Tabs as SharedTabs,
} from "../../styles/shared";
import { mq } from "../../styles/canonical/breakpoints";
import { kpiFaixaCss, kpiTileCss } from "../../components/ListaCompacta/styles";

export const Wrapper = styled(PageContainer)`
  gap: 16px;
  max-width: 1400px;
`;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)``;

export const Titulo = styled(PageTitle)`
  font-weight: 600;
`;

export const TopBarActions = styled(PageActions)`
  @media ${mq.tablet} {
    flex-wrap: nowrap;
    gap: 6px;
  }
`;

// Botao-toggle (so icone + tooltip via title) para ocultar/mostrar ambientes
// por categoria do marceneiro responsavel (Empreitas / Terceirizados).
// $active = filtro ligado (ocultando) -> realce com a cor de acento.
export const FiltroToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme, $active }) =>
    $active ? theme.accent : theme.textSecondary};
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
  }

  @media ${mq.tablet} {
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
  gap: 12px;
  ${kpiFaixaCss}
`;

export const SummaryCard = styled(MetricCard)`
  /* Glass do mockup (sheen + blur), preservando o tom/fundo do card. */
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(13px) saturate(1.3);
  -webkit-backdrop-filter: blur(13px) saturate(1.3);
  ${kpiTileCss}
`;

export const SummaryLabel = styled(MetricLabel).attrs({ className: "kpi-label" })``;

export const SummaryValue = styled(MetricValue).attrs({ className: "kpi-num" })`
  font-weight: 600;
`;

export const SummarySub = styled(MetricSub).attrs({ className: "kpi-sub" })``;

// Abaixo de 1024px: uma linha rolável de chips de 36px (sem quebra).
export const Abas = styled(SharedTabs)`
  @media ${mq.tablet} {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Aba = styled(TabButton)`
  @media ${mq.tablet} {
    flex: 0 0 auto;
    min-height: 36px;
    padding: 6px 12px;
  }
`;

export const SecaoResumoContagem = styled.span`
  margin-left: 8px;
  font-size: 12px;
  opacity: 0.6;
  font-weight: 400;

  @media ${mq.tablet} {
    display: block;
    margin-left: 0;
    margin-top: 2px;
    text-transform: none;
    letter-spacing: 0;
  }
`;

// Linha acima da tabela com o "Restaurar colunas" — sem sentido nos cards.
export const TabelaToolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
`;

export const Secao = styled(Section)``;

export const SecaoTitulo = styled(SectionTitle)``;

export const NoticeCard = styled.div`
  ${({ theme, $tone = "info" }) => {
    const tokens = getToneTokens(theme, $tone);

    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  border-radius: 12px;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.45;
`;

export const MarceneiroButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.accent};
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 220;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 15, 20, 0.58);
`;

export const ModalCard = styled.div`
  width: min(820px, 100%);
  max-height: min(82vh, 760px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.textPrimary};
`;

export const ModalMeta = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const ModalCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    border-color: ${({ theme }) => theme.accent};
  }

  @media ${mq.tablet} {
    width: var(--tap-min, 44px);
    height: var(--tap-min, 44px);
  }
`;

/**
 * TableWrapper LOCAL — sem overflow interno. O scroll vertical e do <body>
 * e o cabecalho da tabela (<Th>) usa position: sticky para ficar fixado
 * logo abaixo do Header global.
 */
export const TableWrapper = styled.div`
  width: 100%;
`;

/**
 * Quando `$density="compact"`, a Tabela seta `data-density="compact"`. Th/Td
 * herdam via seletor de pai — evita passar a prop em cada celula do JSX.
 */
export const Tabela = styled.table.attrs(({ $density }) => ({
  "data-density": $density === "compact" ? "compact" : undefined,
}))`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: ${({ $wide }) => ($wide ? "1080px" : "860px")};

  &[data-density="compact"] {
    font-size: 11px;
    table-layout: fixed;
    min-width: 0;
  }
`;

export const Th = styled.th`
  padding: 10px 12px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  /* Bugfix 2026-05-29 (#13 fix v2): sticky com background OPACO.
     Alpha anterior deixava linhas passarem visualmente atras do
     cabecalho criando efeito empilhado. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  @media ${mq.tablet} {
    font-size: var(--text-min, 12px);
  }
  letter-spacing: 0.06em;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;

  [data-density="compact"] & {
    padding: 6px 10px;
    font-size: 10px;
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  color: ${({ theme, $muted }) => ($muted ? theme.textSecondary : theme.textPrimary)};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
  vertical-align: middle;

  [data-density="compact"] & {
    padding: 4px 10px;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.25;
  }
`;

export const StatusBadge = styled.span`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);

    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  /* Mockup GP (2026-07): badge nunca quebra ("Prazo/vencido" em 2 linhas)
     e leva o pontinho na cor do estado. */
  white-space: nowrap;

  &::before {
    content: "";
    flex: none;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    display: ${({ $tone = "default" }) => ($tone === "default" ? "none" : "block")};
  }
`;

export const EmptyText = styled(SharedEmptyText)`
  padding: 18px 0;
`;

/** Linha clicável: abre o painel do ambiente (datas + histórico). */
export const TrAmbiente = styled.tr`
  cursor: pointer;

  &:hover td {
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;
